import { render, staticRenderFns } from "./SkillZone.vue?vue&type=template&id=61503669&"
import script from "./SkillZone.vue?vue&type=script&lang=js&"
export * from "./SkillZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports